module.exports = __webpack_public_path__ + "img/nav05.eac78646.png";